export const getInitialConfigForPivotChart = (config) => {
  const pivotChartConfig = JSON.parse(JSON.stringify(config));
  let newLayout = [];
  let newLayoutData = {};

  pivotChartConfig.config.layout?.pivot_charts?.forEach((pivotConfig) => {
    const id = pivotConfig.element_config.id;
    newLayout.push(pivotConfig.grid);
    newLayoutData[id] = pivotConfig.element_config;
  });
  return {
    config: pivotChartConfig,
    options: {
      layout: {
        layout: newLayout,
        layoutData: newLayoutData
      }
    }
  };
};
